import React, { useState } from 'react';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';


interface ScheduleToggleProps {
  presetValue: { startTime: string, endTime: string }[];
  onChange: (value: string, playlistId?: string) => void;
  playlistId: string;
}

const ScheduleToggle = ({
    presetValue,
    playlistId,
    onChange
} : ScheduleToggleProps) => {
  const [value, setValue] = useState(presetValue.map((item) => item.startTime + ', ' + item.endTime));

  const handleClick = (event,value) => {
    setValue(value);
    onChange(value, playlistId);
  };

  return (
    <ToggleButtonGroup
      value={value}
      onChange={handleClick}
      style={{width: '260px'}}
      data-testid='toggle button group'
    >
        <ToggleButton data-testid='09-12' value='1970-01-01T09:00:00+01:00, 1970-01-01T11:59:00+01:00'>
            09-12
        </ToggleButton>
        <ToggleButton data-testid='12-15' value='1970-01-01T12:00:00+01:00, 1970-01-01T14:59:00+01:00'>
            12-15
        </ToggleButton>
        <ToggleButton data-testid='15-18' value='1970-01-01T15:00:00+01:00, 1970-01-01T17:59:00+01:00'>
            15-18
        </ToggleButton>
        <ToggleButton data-testid='18-21' value='1970-01-01T18:00:00+01:00, 1970-01-01T20:59:00+01:00'>
            18-21
        </ToggleButton>
        <ToggleButton data-testid='21-09' value='1970-01-01T21:00:00+01:00, 1970-01-01T08:59:00+01:00'>
            21-09
        </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default ScheduleToggle;